import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import NotificationsNone from "@material-ui/icons/NotificationsNone";
import Close from "@material-ui/icons/Close";
import Fade from "@material-ui/core/Fade";
import withStyles from "@material-ui/core/styles/withStyles";
import OSSTooltip from "../OSSTooltip/OSSTooltip";

const styles = theme => ({
  alert: {
    padding: theme.spacing(2),
    margin: [[theme.spacing(2), 0]],
    width: "100%",
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: "700",
    color: "#fff",
    borderRadius: "5px"
  },
  titleRow: { display: "flex", alignItems: "center" },
  success: {
    background: theme.palette.success.main
  },
  notification: {
    background: theme.palette.primary.main
  },
  error: {
    background: theme.palette.error.main
  },
  warning: {
    background: theme.palette.warning.main
  },
  icon: { marginRight: theme.spacing(2) },
  close: {
    marginLeft: "auto",
    width: theme.spacing(2),
    cursor: "pointer"
  }
});

const OSSAlert = ({
  className,
  status,
  classes,
  children,
  showClose = false,
  title,
  tooltipText,
  dismiss = false
}) => {
  const [isDismissed, setIsDismissed] = useState(dismiss);

  useEffect(() => {
    setIsDismissed(dismiss);
  }, [dismiss]);

  const icons = {
    success: CheckCircleOutline,
    notification: NotificationsNone,
    error: ErrorOutline,
    warning: NotificationsNone
  };

  const Icon = icons[status];

  return (
    <Fade in={!isDismissed}>
      <div
        role="alert"
        className={[classes.alert, classes[status], className].join(" ")}
      >
        <div className={classes.titleRow}>
          {tooltipText ? (
            <OSSTooltip className={classes.icon} title={tooltipText}>
              <Icon className={classes.icon} />
            </OSSTooltip>
          ) : (
            <Icon className={classes.icon} />
          )}
          {title ? title : children}
          {showClose && (
            <Close
              className={classes.close}
              onClick={() => setIsDismissed(true)}
            />
          )}
        </div>
        {title && <div>{children}</div>}
      </div>
    </Fade>
  );
};

OSSAlert.propTypes = {
  status: PropTypes.oneOf(["error", "notification", "success", "warning"])
    .isRequired
};

export default withStyles(styles)(OSSAlert);
